import React from "react";
import { Plus } from "../Icons";

const UpdateTimeSlotModal = ({
  open,
  allDays,
  form,
  setForm,
  errorMessage,
  isSubmitting,
  isSubmitDisabled,
  onClose,
  onSubmit,
}) => {
  if (!open) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div className="w-full font-['Inter'] max-w-[627px] rounded-2xl bg-white p-8">
        <div className="flex items-center gap-4 text-2xl font-semibold text-black">
          <Plus />
          Update Time Slot
        </div>

        <div className="mt-7">
          <div>
            <label className="text-[22px] leading-normal font-medium text-black">
              Session Title
            </label>
            <input
              type="text"
              value={form.sessionTitle}
              onChange={(event) =>
                setForm((prev) => ({
                  ...prev,
                  sessionTitle: event.target.value,
                }))
              }
              className="mt-2 w-full rounded-lg border border-[#D9D9D9] px-3 py-4"
            />
          </div>

          <div className="mt-5">
            <label className="text-[22px] leading-normal font-medium text-black">
              Schedule Type
            </label>
            <p className="mt-2 rounded-lg border border-[#D9D9D9] bg-[#FAFAFA] px-3 py-4 text-[#4E5566]">
              Recurring Weekly
            </p>
          </div>

          <div className="mt-5">
            <label className="text-[22px] leading-normal font-medium text-black">
              Select day(s)
            </label>
            <div className="mt-5 grid grid-cols-4 gap-6">
              {allDays.map((day) => {
                const checked = form.days.includes(day);
                return (
                  <label
                    key={day}
                    className="flex items-center gap-3 text-[22px] font-medium text-black leading-normal"
                  >
                    <input
                      type="checkbox"
                      checked={checked}
                      onChange={(event) => {
                        setForm((prev) => {
                          const nextDays = event.target.checked
                            ? [...prev.days, day]
                            : prev.days.filter((d) => d !== day);
                          return { ...prev, days: nextDays };
                        });
                      }}
                      className="h-[30px] w-[30px] appearance-none rounded border-2 border-[#0D99FF] bg-white checked:border-[#0D99FF] checked:bg-[#0D99FF] checked:bg-[url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2020%2016%22%3E%3Cpath%20fill%3D%22%23FFFFFF%22%20d%3D%22M7.5%2013.2L1.9%207.6l1.8-1.8%203.8%203.8%208-8%201.8%201.8z%22/%3E%3C/svg%3E')] checked:bg-no-repeat checked:bg-center checked:bg-[length:18px_14px]"
                    />
                    {day}
                  </label>
                );
              })}
            </div>
          </div>

          <div className="mt-11 grid grid-cols-1 gap-6 sm:grid-cols-2">
            <div>
              <label className="text-[22px] leading-normal font-medium text-black">
                Start Time
              </label>
              <input
                type="time"
                value={form.startTime}
                onChange={(event) =>
                  setForm((prev) => ({
                    ...prev,
                    startTime: event.target.value,
                  }))
                }
                className="mt-2 w-full text-xl text-black rounded-lg border border-[#D9D9D9] px-3 py-[13px]"
              />
            </div>
            <div>
              <label className="text-[22px] leading-normal font-medium text-black">
                End Time
              </label>
              <input
                type="time"
                value={form.endTime}
                onChange={(event) =>
                  setForm((prev) => ({
                    ...prev,
                    endTime: event.target.value,
                  }))
                }
                className="mt-2 w-full text-black text-xl rounded-lg border border-[#D9D9D9] px-3 py-[13px]"
              />
            </div>
          </div>
        </div>

        {errorMessage ? (
          <p className="mt-5 text-sm font-medium text-[#DC2626]">
            {errorMessage}
          </p>
        ) : null}

        <div className="mt-5 flex items-center justify-end gap-6">
          <button
            type="button"
            className="rounded bg-[#FDFDFD] border border-[#D9D9D9] px-[26px] py-2 text-lg font-medium text-[#323232]"
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="rounded bg-[#089BC4] px-12 py-[9px] text-lg font-medium text-white"
            onClick={onSubmit}
            disabled={isSubmitting || isSubmitDisabled}
          >
            {isSubmitting ? "Updating..." : "Update Time Slot"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateTimeSlotModal;
